/*
jQuery( document ).ready(function() {
    var link = jQuery('a[href^="tel:"]');
    //console.log(link);
	link.attr('onClick', "gtag('event','click',{'event_category':'phonecall','event_label':'c2c'});");
});
*/


(function($, window, document, _undefined){
	$(document).ready(function(){
		
		thisthing = $("[href^='tel:']");
		thisthing.click(function(){
			gtag('event', 'click', {'event_category': 'phonecall','event_label': 'c2c', 'value' : thisthing.html()});
		});

	});
		
})(jQuery, this, document);





// WEBPACK FOOTER //
// ./assets/js/c2c-gtag.js